import {Objetivo} from "./objetivo";

export class ObjetivoAtividade {

    id: number;
    objetivo: Objetivo;
    idAtividade: number;
    usuarioAlteracao: number;
    idInstituicao: number;

}
